var map = {
	"./store-reg-banner-01.png": "2288",
	"./store-reg-banner-02.png": "5772",
	"./store-reg-banner-03.png": "a588",
	"./store-reg-banner-04.png": "67a6",
	"./store-reg-banner-05.png": "5514",
	"./store-reg-banner-06.png": "71bc7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4dff";